import React from 'react';
import PropTypes from 'prop-types';

const Button = props => {
  const { text, color, icon, click, propClass } = props;

  return (
    <button
      className={`button ${color ? `button--${color}` : ''} ${propClass ? propClass : ''}`}
      onClick={click}>
      <span className="button__text">{text}</span>
      {icon ? <span className="icon-small-arrow" /> : ''}
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.bool,
  click: PropTypes.func,
  propClass: PropTypes.string,
};

export default Button;
